/**
 * Fail-closed venue dispatch for write paths (#987).
 *
 * Several surfaces historically branched `venue === 'kalshi' ? A : B`, so any
 * venue that was not Kalshi silently took the international Polymarket (or
 * Kalshi) path. Adding Polymarket US makes that a wrong-venue write. Every
 * place/cancel/edit dispatch must name each venue it supports and end in this
 * guard: once the venue union widens, TypeScript flags the unhandled case at
 * compile time, and at runtime an unexpected value refuses instead of routing.
 */
export class UnsupportedVenueError extends Error {
  constructor(readonly venue: string, readonly action: string) {
    super(`${action} is not available for this venue`);
    this.name = 'UnsupportedVenueError';
  }
}

export function unsupportedVenue(venue: never, action: string): never {
  throw new UnsupportedVenueError(String(venue), action);
}
